import PropTypes from 'prop-types';

const Join = ({ color, size, ...props }) => (
    <svg viewBox="0 0 20 20" width={size} height={size} {...props}>
        <path
            d="M2.25 4A.75.75 0 0 1 3 3.25h1.91a5.75 5.75 0 0 1 5.143 3.179l.236.472A4.25 4.25 0 0 0 14.09 9.25h2.1l-1.72-1.72a.75.75 0 0 1 1.06-1.06l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72h-2.1a4.25 4.25 0 0 0-3.801 2.35l-.236.472A5.75 5.75 0 0 1 4.91 16.75H3a.75.75 0 0 1 0-1.5h1.91A4.25 4.25 0 0 0 8.71 12.9l.236-.472A5.75 5.75 0 0 1 11.251 10a5.75 5.75 0 0 1-2.304-2.429L8.711 7.1A4.25 4.25 0 0 0 4.91 4.75H3A.75.75 0 0 1 2.25 4"
            fill={color}
            fillRule="evenodd"
        />
    </svg>
);

export default Join;

Join.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
